import pipe from 'lodash/fp/pipe';

import { isBrowser } from '../conditions';
import { devLoggerDeepLink } from '../devLogger';
import { toQueryString } from '../router';

export const callDeepLink = (path: string) =>
  pipe(devLoggerDeepLink(path), (query) => {
    if (!isBrowser()) {
      return console.warn('Should invoke callDeepLink in client');
    }
    if (path.startsWith('/open/') || path.startsWith('open/')) {
      return console.error('open prefix is not allowed in path');
    }
    const queryString = toQueryString(query);
    const base = 'zigzag://open';
    const handled_path = (!path.startsWith('/') ? '/' : '') + path;
    const handled_query = queryString ? '?' + queryString : '';
    const deeplinkUrl = base + handled_path + handled_query;

    window.location.assign(deeplinkUrl);
  });
